import React, { useContext } from 'react';
import './Header.css';

import CbmContext from '../../Context/Cbm/cbmContext';
import CbmLogoWhite from '../../images/carlson_logo-inverted.png';
import { Link } from 'react-router-dom';

const Header = (props) => {
  const cbmContext = useContext(CbmContext);
  const { auth, portalUser } = cbmContext;
  return (
    <div className="headerContainer">
      <div className="header">
        <div className="carlsonLogo">
          <img alt="Carlson Logo" src={CbmLogoWhite} width={'100%'} />
        </div>
        <div className="headerLinks">
          {auth && (
            <div className="homeLink">
              <Link to="/">Home</Link>
            </div>
          )}
          <div className="login-admin-links">
            <div className="loginLink">
              {auth ? (
                <Link to="/logout">Logout</Link>
              ) : (
                <Link to="/login">Login</Link>
              )}
            </div>
            {(portalUser?.permission === 'Admin' ||
              portalUser?.permission === 'Office' ||
              portalUser?.permission === 'DM' ||
              portalUser?.permission === 'AS' ||
              portalUser?.authorities?.some(
                (authority) => authority?.authority === 'AS'
              )) && (
              <div className="adminLink">
                <Link to="/admin">Admin</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {};

export default Header;
